<template>
    <nav class="flex" :aria-label="$t('general.tabs_aria_label')">
        <template v-for="tab in tabs" :key="tab.id">
            <router-link v-if="tab.to" :to="tab.to" custom v-slot="{ isActive, navigate }">
                <button
                    type="button"
                    :aria-current="isActive ? 'page' : undefined"
                    :data-testid="tab.testId"
                    :class="tabClasses(isActive, tab.disabled)"
                    @click="navigate"
                >
                    {{ tab.label }}
                </button>
            </router-link>
            <button
                v-else
                type="button"
                :aria-pressed="modelValue === tab.id"
                :disabled="tab.disabled"
                :data-testid="tab.testId"
                :class="tabClasses(modelValue === tab.id, tab.disabled)"
                @click="$emit('update:modelValue', tab.id)"
            >
                {{ tab.label }}
            </button>
        </template>
    </nav>
</template>

<script>
/**
 * Underlined tab row shared across the app. Tabs either switch local state via
 * v-model (`id`) or navigate when given a `to` route, in which case the router
 * decides which one is active.
 *
 * Tab shape: { id, label, to?, disabled?, testId? }
 */
export default {
    name: 'TabBar',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            default: null,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        tabClasses(isActive, isDisabled) {
            return [
                'font-title relative flex h-12 min-w-0 flex-1 items-center justify-center border-b px-4 text-center text-xs leading-3 font-extrabold uppercase transition-colors',
                isActive
                    ? 'tab-glow border-red-600 text-red-600'
                    : 'border-stroke-2 text-titles hover:text-white',
                isDisabled ? 'pointer-events-none opacity-20' : 'cursor-pointer',
            ]
        },
    },
}
</script>
